module.exports = __webpack_public_path__ + "Jp_NODjpCf2_Q0OCv/rdc_pro_logo.svg";